import {Box, styled} from "@mui/material";
import React from "react";
import LinearDiagram from "./LinearDiagram";
import UseCaseTradingBlock from "./UseCaseTradingBlock";

const UseCasesTryToContainer = styled(Box)({
    display: "grid",
    gridTemplateColumns: "1fr 2fr",
    padding: "10px 20px",
    boxSizing: "border-box",
    alignItems: "baseline",
    columnGap: "20px",
    marginBottom: "20px",
    "@media(max-width: 768px)":{
        gridTemplateColumns: "1fr",
        rowGap: "20px",
    },
});

const UseCasesTryTo = ():JSX.Element => {
    return (
        <UseCasesTryToContainer id={"interactiveexamples"}>
            <UseCaseTradingBlock/>
            <LinearDiagram
                height={"400px"}
                id={"tradingDiagramsEl"}
                generateFor={30}
                generateFuture={10}
            />
        </UseCasesTryToContainer>
    );
};

export default UseCasesTryTo;
